import React, { useState } from 'react';
import styled from 'styled-components';
import { Title } from '../../VisualComponents';
import ModeCard from './ModeCard';

const StartMenuContainer = styled.div`
    grid-area: 2 / 2 / 2 / 2;
    display: flex;
    flex-direction: column;
    ${({ closing }) => closing ? 'opacity: 0;' : ''}
    transition: opacity 0.2s;
    @media only screen 
		and (orientation: portrait) {
            grid-area: 2 / 1 / 2 / 4;
	}
`

const TitleContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
`

const ModesContainer = styled.div`
    display: flex;
    flex: 2;
    flex-direction: row;
    justify-content: space-between;
    @media only screen 
		and (orientation: portrait)
        and (max-width: 400px) {
            width: 100%;
            justify-content: space-evenly;
            flex-direction: column;
            flex: 4;
	}
` 

function StartMenu({ onSelect }) {
    const [closeAnimation, setCloseAnimation] = useState(false)
    const handleModeSelect = (mode) => {
        setCloseAnimation(true)
        setTimeout(() => {
            switch (mode) {
                case 'infinite': onSelect({
                    mode: 'infinite',
                    pads: 'all',
                    timeLimit: false,
                }); return;
                case 'trainig': onSelect({
                    mode: 'infinite',
                    pads: 'all',
                    timeLimit: false,
                }); return;
                default: return;
            }
        }, 200)
    }

    return (
        <StartMenuContainer closing={closeAnimation}>
            <TitleContainer>
                <Title>Vyberte režim hry</Title>
            </TitleContainer>
            <ModesContainer>
                <ModeCard mode="infinite" onClick={() => handleModeSelect('infinite')}/>
                <ModeCard mode="training" onClick={() => handleModeSelect('trainig')}/>
                {/* <ModeCard mode="custom"/> */}
            </ModesContainer>
        </StartMenuContainer>
    );
}

export default StartMenu;